import { LegalLayout } from "@/components/LegalLayout/LegalLayout";
import { Header } from "@/components/header/Header";
import { Footer } from "@/components/Footer/Footer";

export default function DisclosuresPage() {
  const lastUpdated = "October 24, 2025";

  return (
    <>
      <Header />

      <section className="bg-gradient-to-b from-stone-900 via-stone-800 to-stone-900 py-24 sm:py-28 lg:py-32 px-4 sm:px-6 lg:px-8 text-white text-center">
        <div className="mx-auto max-w-4xl space-y-6">
          <span className="inline-block rounded-full bg-stone-700/60 px-4 py-1.5 text-xs font-semibold tracking-wider uppercase text-stone-300">
            Transparency
          </span>

          <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
            Legal Disclosures
          </h1>

          <p className="mx-auto max-w-2xl text-base leading-relaxed text-stone-300">
            Important legal information, certifications, regulatory disclosures,
            and transparency statements regarding our business operations and
            services.
          </p>

          <div className="pt-3 text-sm text-stone-400">
            Last updated:{" "}
            <span className="font-medium text-stone-200">{lastUpdated}</span>
          </div>
        </div>
      </section>

      <LegalLayout activeTab="disclosures" />

      <Footer />
    </>
  );
}